import React, { Component } from "react";
import style from "../../assets/css/modules/claims/claims-summary-desktop-row.css";
import Contentify from "../../content/Contentify";
import Store from "../../content/Store";
import CellWithTwoLabels from "../shared/groups/CellWithTwoLabels";

class ClaimsConditionContainer extends Component {
    static content = Store.Claims;
    render(){
        return (
            <div className={`row ${style.rowTopMargin}  ${this.props.isMobileDevice || this.props.isTabletDevice ? style.rowMarginSides : " "}`}>
                <div className={"col-1 " + style.paddingRightForIcon}>
                          <i
                            className={
                              "icon-claims-shield " +
                              style.claimRowIcon +
                              " " +
                              style.floatIconRight
                            }
                          />
                        </div>
                        <div className={"col-5 " + style.removeLeftPadding}>
                          <CellWithTwoLabels
                            topLabel={this.props.claimscondition.HealthConditionDescription.charAt(0).toUpperCase() + this.props.claimscondition.HealthConditionDescription.slice(1)}
                            bottomLabel={this.props.content.ClaimNumber + ": "+ this.props.claimscondition.ConditionApprovalNumber}
                          />
                        </div>
                        <div className={"col-3 "}>
                        </div>
                        <div
                                  className={
                                    style.centeredVertically +
                                    " col-3 text-right " +
                                    style.benefitStatementLink
                                  }
                                >
                                    {this.props.content.Lastupdated+" "+new Date(this.props.claimscondition.LastUpdatedDate)?.toLocaleDateString()}
                                </div>
            </div>
        );
    }
}

export default Contentify(ClaimsConditionContainer);